module.exports = __webpack_public_path__ + "img/bottom-design.ca3fe5b2.png";